// src/pages/Dashboard/hooks/useReportFilters.js
import { useCallback, useMemo, useState } from "react";

/**
 * Encapsulates the dashboard's filter state (project, month/year,
 * comparison mode) and exposes a `filteredReports` array derived from
 * the raw report list.
 */
export default function useReportFilters(allReports) {
  const [projectId, setProjectId] = useState("ALL");
  const [selectedMonth, setSelectedMonth] = useState("ALL");
  const [selectedYear, setSelectedYear] = useState("ALL");
  const [comparisonMode, setComparisonMode] = useState(false);

  const setMonthYear = useCallback((value) => {
    if (value === "ALL") {
      setSelectedMonth("ALL");
      setSelectedYear("ALL");
      return;
    }
    const [month, year] = value.split("-");
    setSelectedMonth(month);
    setSelectedYear(year);
  }, []);

  const monthYearValue =
    selectedMonth === "ALL" ? "ALL" : `${selectedMonth}-${selectedYear}`;

  const filteredReports = useMemo(() => {
    let filtered = allReports;

    if (projectId !== "ALL" && !comparisonMode) {
      filtered = filtered.filter(
        (r) => String(r?.project?._id) === String(projectId),
      );
    }

    if (selectedMonth !== "ALL") {
      filtered = filtered.filter((r) => {
        const d = new Date(r.createdAt);
        return (
          d.getMonth() + 1 === Number(selectedMonth) &&
          d.getFullYear() === Number(selectedYear)
        );
      });
    }

    return filtered;
  }, [allReports, projectId, selectedMonth, selectedYear, comparisonMode]);

  return {
    projectId,
    setProjectId,
    monthYearValue,
    setMonthYear,
    comparisonMode,
    setComparisonMode,
    filteredReports,
  };
}
